import { PropsSVG } from "./types";

function BellIcon({ ...props }: PropsSVG) {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="2.13916"
        y="20.0625"
        width="17.0343"
        height="5.41999"
        rx="2.32285"
        fill="#F6F6F6"
        stroke="#3C3C3C"
        strokeWidth="1.54857"
      />
      <rect
        x="5.23633"
        y="3.41528"
        width="17.0343"
        height="5.41999"
        rx="2.32285"
        stroke="#3C3C3C"
        strokeWidth="1.54857"
      />
      <rect
        x="2.13916"
        y="8.83545"
        width="17.0343"
        height="5.41999"
        rx="2.32285"
        stroke="#3C3C3C"
        strokeWidth="1.54857"
      />
      <rect
        x="4.46191"
        y="14.2551"
        width="17.0343"
        height="5.41999"
        rx="2.32285"
        stroke="#3C3C3C"
        strokeWidth="1.54857"
      />
      <ellipse
        cx="20.9092"
        cy="19.4845"
        rx="9.09132"
        ry="9.10049"
        fill="#01C246"
        stroke="#3C3C3C"
        strokeWidth="1.54857"
      />
      <path
        d="M20.9572 25.4506C20.7274 25.4506 20.5333 25.3696 20.3748 25.2075C20.2164 25.0455 20.1371 24.8429 20.1371 24.5999V23.7005L20.4937 24.0286C19.9628 24.0043 19.5033 23.9355 19.115 23.822C18.7268 23.7086 18.4099 23.5952 18.1643 23.4817C17.9583 23.3845 17.8117 23.2467 17.7245 23.0685C17.6453 22.8902 17.6136 22.7079 17.6294 22.5216C17.6532 22.3352 17.7206 22.1651 17.8315 22.0111C17.9424 21.8572 18.085 21.7559 18.2593 21.7073C18.4416 21.6506 18.6515 21.6749 18.8892 21.7802C19.0477 21.8693 19.2854 21.9625 19.6023 22.0597C19.9272 22.1489 20.3273 22.1934 20.8027 22.1934C21.1354 22.1934 21.3969 22.161 21.5871 22.0962C21.7851 22.0314 21.9238 21.9463 22.003 21.841C22.0902 21.7275 22.1338 21.606 22.1338 21.4764C22.1338 21.3548 22.1021 21.2535 22.0387 21.1725C21.9832 21.0834 21.8881 21.0064 21.7534 20.9416C21.6188 20.8687 21.4326 20.8039 21.1949 20.7471L19.8519 20.4555C19.115 20.2853 18.5644 20.0017 18.1999 19.6047C17.8434 19.1996 17.6651 18.677 17.6651 18.0369C17.6651 17.5507 17.78 17.1172 18.0098 16.7364C18.2475 16.3475 18.5763 16.0315 18.9962 15.7884C19.424 15.5454 19.9232 15.3914 20.4937 15.3266L20.1371 15.5332V14.7189C20.1371 14.4758 20.2164 14.2733 20.3748 14.1112C20.5333 13.9492 20.7274 13.8682 20.9572 13.8682C21.1949 13.8682 21.3929 13.9492 21.5514 14.1112C21.7099 14.2733 21.7891 14.4758 21.7891 14.7189V15.5332L21.4326 15.3023C21.7336 15.3104 22.0585 15.3631 22.4071 15.4603C22.7557 15.5494 23.0608 15.675 23.3222 15.8371C23.5045 15.9343 23.6312 16.068 23.7025 16.2381C23.7818 16.4083 23.8095 16.5825 23.7857 16.7607C23.7699 16.9309 23.7065 17.0848 23.5956 17.2226C23.4926 17.3603 23.35 17.4535 23.1677 17.5021C22.9934 17.5426 22.7835 17.5102 22.5378 17.4049C22.3556 17.3239 22.1496 17.259 21.9198 17.2104C21.698 17.1537 21.4128 17.1253 21.0641 17.1253C20.6442 17.1253 20.3194 17.2023 20.0896 17.3563C19.8677 17.5102 19.7568 17.7087 19.7568 17.9518C19.7568 18.1138 19.8202 18.2516 19.947 18.365C20.0817 18.4704 20.3233 18.5635 20.6719 18.6446L22.0268 18.9484C22.7795 19.1185 23.3341 19.4021 23.6907 19.7992C24.0551 20.1881 24.2374 20.6945 24.2374 21.3184C24.2374 21.8045 24.1225 22.2339 23.8927 22.6067C23.6629 22.9794 23.342 23.2832 22.93 23.5182C22.526 23.7531 22.0545 23.9071 21.5158 23.98L21.7891 23.6883V24.5999C21.7891 24.8429 21.7099 25.0455 21.5514 25.2075C21.4009 25.3696 21.2028 25.4506 20.9572 25.4506Z"
        fill="white"
      />
    </svg>
  );
}

export default BellIcon;
